import {
	ArrowRightIcon,
	BookOpen,
	Globe,
	Mail,
	Newspaper,
	Phone,
	Twitter,
} from 'lucide-react'
import { Suspense } from 'react'
import { Link } from 'react-router'

import { SplineViewer } from '#app/components/spline-viewer.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { type Route } from '#app/routes/_marketing+/+types/index.ts'

export const meta: Route.MetaFunction = () => [{ title: 'Lydra AI' }]

export default function RootRoute() {
	const ignoredChannels = [
		{ name: 'Phone', icon: Phone, type: 'Intake' },
		{ name: 'Email', icon: Mail, type: 'Intake' },
		{ name: 'Web', icon: Globe, type: 'Intake' },
		{ name: 'Social', icon: Twitter, type: 'Monitor' },
		{ name: 'Literature', icon: BookOpen, type: 'Monitor' },
		{ name: 'News', icon: Newspaper, type: 'Monitor' },
	]

	return (
		<div className="relative mx-4 flex h-[calc(100vh-126px)] items-end p-6 md:mx-12 md:p-16">
			<div className="absolute top-0 right-0 bottom-0 left-0 overflow-hidden rounded-xl bg-neutral-100">
				<Suspense
					fallback={
						<div className="flex h-full w-full items-center justify-center">
							<div className="animate-pulse text-neutral-400">Loading...</div>
						</div>
					}
				>
					<SplineViewer scene="https://prod.spline.design/1UjZlPEUBkIEmBpR/scene.splinecode" />
				</Suspense>
			</div>
			{/* <AnimatedWave /> */}
			<div className="relative flex-grow">
				{/*<InfiniteScrollCards
					items={[
						{ name: 'Sarah', role: 'AE Intake Specialist', seed: 'sarah' },
						{ name: 'Marcus', role: 'Medical Coder', seed: 'marcus' },
						{ name: 'Sophia', role: 'ICSR Writer', seed: 'sophia' },
						{ name: 'James', role: 'QA Reviewer', seed: 'james' },
						{ name: 'Lily', role: 'Causality Assessor', seed: 'lily' },
						{ name: 'Oliver', role: 'Medical Reviewer', seed: 'oliver' },
						{ name: 'Ava', role: 'Signal Detection Specialist', seed: 'ava' },
						{ name: 'Noah', role: 'Literature Reviewer', seed: 'noah' },
						{ name: 'Maya', role: 'Case Processor', seed: 'maya' },
						{ name: 'Ethan', role: 'Submission Coordinator', seed: 'ethan' },
						{ name: 'Zoe', role: 'Safety Database Manager', seed: 'zoe' },
						{ name: 'Lucas', role: 'Compliance Officer', seed: 'lucas' },
					]}
					renderItem={(member, i) => (
						<div
							key={i}
							className="flex h-28 w-32 flex-shrink-0 flex-col items-start gap-2 rounded-lg bg-neutral-200 p-3"
						>
							<img
								src={`https://api.dicebear.com/7.x/adventurer-neutral/svg?seed=${member.seed}`}
								alt={member.name}
								className="h-12 w-12 rounded-full"
							/>
							<div className="w-full text-left">
								<div className="truncate text-xs font-medium text-neutral-700">
									{member.name}
								</div>
								<div className="truncate text-xs text-neutral-500">
									{member.role}
								</div>
							</div>
						</div>
					)}
					className="animate-slide-top absolute top-8 right-0 left-0 mb-8 [animation-delay:0.1s] [animation-fill-mode:backwards]"
					animationDuration={40}
				/>*/}
				<style>
					{`
						@keyframes scroll {
							0% { transform: translateX(0); }
							100% { transform: translateX(-50%); }
						}
						.animate-scroll {
							animation: scroll 40s linear infinite;
							width: 200%;
						}
					`}
				</style>
				<div className="relative z-10 mt-46 max-w-[700px]">
					<h1
						data-cy="homepage-header"
						className="animate-slide-top mb-4 text-left text-3xl font-normal [animation-delay:0.2s] [animation-fill-mode:backwards] md:text-4xl"
						style={{ lineHeight: '1.4' }}
					>
						<span className="md:hidden">
							AI Intake & Case Processing for Pharmacovigilance
						</span>
						<span className="hidden md:inline">
							AI Intake & Case Processing for
							<br />
							Pharmacovigilance
						</span>
					</h1>
					<p className="animate-slide-top mb-6 text-left text-lg [animation-delay:0.3s] [animation-fill-mode:backwards]">
						From intake to ICSR submission. Intake adverse events on{' '}
						<strong className="font-bold">multiple</strong> channels.{' '}
						<span className="hidden sm:inline">
							<br />
						</span>
						Stay compliant on <strong className="font-bold">one</strong>{' '}
						platform.
					</p>

					{/* Channel intake cards */}
					{/* <div className="animate-slide-top mb-6 [animation-delay:0.4s] [animation-fill-mode:backwards]">
						{/* Desktop: Static row */}
					{/* <div className="hidden gap-4 sm:flex">
							{channels.map((channel, i) => {
								const IconComponent = channel.icon
								return (
									<div
										key={i}
										className="flex w-24 flex-shrink-0 flex-col items-center gap-2 rounded-lg bg-neutral-200 p-3"
									>
										<IconComponent className="h-7 w-7 text-neutral-600" />
										<div className="w-full text-center">
											<div className="truncate text-xs font-medium text-neutral-700">
												{channel.name}
											</div>
											<div className="truncate text-xs text-neutral-500">
												{channel.type}
											</div>
										</div>
									</div>
								)
							})}
						</div>

						{/* Mobile: Scrolling */}
					{/* <InfiniteScrollCards
							items={channels}
							renderItem={(channel, i) => {
								const IconComponent = channel.icon
								return (
									<div
										key={i}
										className="flex h-24 w-24 flex-shrink-0 flex-col items-center gap-2 rounded-lg bg-neutral-200 p-3"
									>
										<IconComponent className="h-7 w-7 text-neutral-600" />
										<div className="w-full text-center">
											<div className="truncate text-xs font-medium text-neutral-700">
												{channel.name}
											</div>
											<div className="truncate text-xs text-neutral-500">
												{channel.type}
											</div>
										</div>
									</div>
								)
							}}
							className="sm:hidden"
							animationDuration={30}
						/>
					</div> */}

					<div className="animate-slide-top flex flex-col items-start space-y-2 [animation-delay:0.5s] [animation-fill-mode:backwards] md:flex-row md:space-y-0 md:space-x-4">
						<Link to="https://calendly.com/mo-curigenx/30min" className="block">
							<Button className="md:w-fit">
								Book a demo
								<ArrowRightIcon className="ml-1 h-4 w-4" />
							</Button>
						</Link>
					</div>
					<div className="animate-slide-top mt-6 flex justify-start [animation-delay:0.6s] [animation-fill-mode:backwards]">
						<YCombinator />
					</div>
				</div>
				<style>
					{`
						@keyframes scroll {
							0% { transform: translateX(0); }
							100% { transform: translateX(-50%); }
						}
					`}
				</style>
			</div>
		</div>
	)
}

function YCombinator() {
	return (
		<div className="animate-slide-top flex flex-col gap-y-1.5 [animation-delay:0.6s] [animation-fill-mode:backwards]">
			<div className="text-muted-foreground text-xs tracking-wide uppercase">
				Backed by
			</div>
			<span className="flex items-center gap-1 text-sm tracking-wide">
				<img src="/img/yc-dark.svg" alt="YC logo" className="h-5 w-5" />
				<span>Combinator</span>
			</span>
		</div>
	)
}

function ignoredInfiniteScrollCards<T>({
	items,
	renderItem,
	className = '',
	animationDuration = 40,
	duplicateCount = 2,
}: {
	items: T[]
	renderItem: (item: T, index: number) => React.ReactNode
	className?: string
	animationDuration?: number
	duplicateCount?: number
}) {
	const duplicatedItems = Array.from(
		{ length: duplicateCount },
		() => items,
	).flat()

	return (
		<div className={`overflow-hidden ${className}`}>
			<div
				className="flex gap-3"
				style={{
					animation: `scroll ${animationDuration}s linear infinite`,
					width: `${duplicateCount * 100}%`,
				}}
			>
				{duplicatedItems.map((item, index) => renderItem(item, index))}
			</div>
		</div>
	)
}
